import Vue from 'vue'
import Router from 'vue-router'
import bar from './routers/bar'
import system from './routers/system'
import examination from './routers/examination'
import studentBar from './routers/studentBar'
import student from './routers/student'

const login = () =>
    import('./views/frame/login');
const index = () =>
    import('./views/frame/index');
const personal = () =>
    import('./views/frame/personal');
const studentIndex = () =>
    import('./views/frame/studentIndex');
const studentPersonal = () =>
    import('./views/frame/studentPersonal');
const regist = () =>
    import('./views/frame/regist');
Vue.use(Router);
/**
 *test
 *
 */
export default new Router({
    routes: [
        {
            path: '/',
            redirect: '/login'
        },
        {
            path: '/login',
            name: 'login',
            component: login
        },
        {
            path: '/regist',
            name: 'regist',
            component: regist
        },
        {
            path: '/index',
            name: 'index',
            component: index,
            children: [
                {
                    path: '/personal',
                    name: 'personal',
                    component: personal
                },
                ...bar,
                ...system,
                ...examination,
            ]
        },
        {
            path: '/studentIndex',
            name: 'studentIndex',
            component: studentIndex,
            children: [
                {
                    path: '/studentPersonal',
                    name: 'studentPersonal',
                    component: studentPersonal
                },
                ...studentBar,
                ...student,
            ]
        }

    ]
})
